module.exports = __webpack_public_path__ + "img/餐饮补助@2x.72915b0e.png";